import React from "react";
import ManageAllInvoices from "../component/sections/finance/manage/ManageAllInvoices";
import ManageAllPledge from "../component/sections/finance/manage/AllPledge";
import AllTransaction from "../component/sections/finance/manage/AllTransaction";
import AddTransaction from "../component/sections/finance/manage/AddTransaction";
import ManageOfficialInvoice from "../component/sections/finance/manage/ManageOfficialInvoice";
import middleware from "./middlewares/middleware";
import LogWallet from "../component/sections/finance/manage/LogWallet";
import AllGift from "../component/sections/finance/manage/gifts/AllGift";
import AddGift from "../component/sections/finance/manage/gifts/AddGift";
import EditGift from "../component/sections/finance/manage/gifts/EditGift";
import AllLogEditGift from "../component/sections/finance/manage/gifts/AllLogEditGift";
import ViewLogEditGift from "../component/sections/finance/manage/gifts/ViewLogEditGift";
import UsersUseThisGifts from "../component/sections/finance/manage/gifts/UsersUseThisGifts";
import ManageMarketerAskCheckout from "../component/sections/marketer/checkout/manage/ManageMarketerAskCheckout";
import ManageMarketerViewAskCheckout from "../component/sections/marketer/checkout/manage/ManageMarketerViewAskCheckout";
import AllGiftRegisterUser from "../component/sections/finance/manage/gift-register-user/All";
import AddGiftRegisterUser from "../component/sections/finance/manage/gift-register-user/Add";
import EditGiftRegisterUser from "../component/sections/finance/manage/gift-register-user/Edit";
import ListUsesGiftRegisterUser from "../component/sections/finance/manage/gift-register-user/AllGiftUses";
import AddGiftChargeUser from "../component/sections/finance/manage/gift-charge-user/Add";
import AllGiftChargeUser from "../component/sections/finance/manage/gift-charge-user/All";
import RangeValueToGiftChargeUser from "../component/sections/finance/manage/gift-charge-user/RangeValue";
import EditGiftChargeUser from "../component/sections/finance/manage/gift-charge-user/Edit";
import ViewGiftChargeUser from "../component/sections/finance/manage/gift-charge-user/View";

const financeRoutes = [
  {
    path: "/finance/manage/invoices",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageAllInvoices />,
        "ManageAllInvoices"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/all-transaction",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllTransaction />,
        "AllTransaction"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/add-transaction",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddTransaction />,
        "AddTransaction"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/invoice/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageOfficialInvoice />,
        "ManageOfficialInvoice"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/pledge",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageAllPledge />,
        "ManageAllPledge"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/log-wallet",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <LogWallet />,
        "LogWallet"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/all-gift",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllGift />,
        "AllGift"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/add-gift",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddGift />,
        "AddGift"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/edit-gift/:giftID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditGift />,
        "EditGift"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift/log/:giftID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllLogEditGift />,
        "AllLogEditGift"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift/log/view/:logID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewLogEditGift />,
        "ViewLogEditGift"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift/users-use/:giftID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <UsersUseThisGifts />,
        "UsersUseThisGifts"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/marketer/ask-checkout",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageMarketerAskCheckout />,
        "ManageMarketerAskCheckout"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/marketer/ask-checkout/:askCheckoutID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageMarketerViewAskCheckout />,
        "ManageMarketerViewAskCheckout"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift-register-user/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllGiftRegisterUser />,
        "AllGiftRegisterUser"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift-register-user/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddGiftRegisterUser />,
        "AddGiftRegisterUser"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift-register-user/edit/:giftID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditGiftRegisterUser />,
        "EditGiftRegisterUser"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift-register-user/list-uses/:giftID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ListUsesGiftRegisterUser />,
        "ListUsesGiftRegisterUser"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift-charge-user/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllGiftChargeUser />,
        "AllGiftChargeUser"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift-charge-user/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddGiftChargeUser />,
        "AddGiftChargeUser"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift-charge-user/:giftChargeUserID/ranges-value",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <RangeValueToGiftChargeUser />,
        "RangeValueToGiftChargeUser"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift-charge-user/:giftChargeUserID/edit",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditGiftChargeUser />,
        "EditGiftChargeUser"
      );
    },
    exact: true,
  },
  {
    path: "/finance/manage/gift-charge-user/:giftChargeUserID/view",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewGiftChargeUser />,
        "ViewGiftChargeUser"
      );
    },
    exact: true,
  },
];

export default financeRoutes;
